import React, { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { VegRequirementFilter } from '../../components/Filter/VegRequirementFilter';
import IngredientBatchModel from '../../components/IngredientBatchModel';
import axios from 'axios';
import { baseUrl } from '../../comman/config';
import Select from 'react-select';
import Loader from "../../components/Loader.js";
import NoRecordsFound from "../../components/NoRecordsFound.js";


function ReceiptList() {
  const today = new Date().toISOString().split("T")[0];
  const [ingredientReceiptList, setIngredientReceiptList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [receiptStatus, setReceiptStatus] = useState([]);
  const [ingredient, setIngredient] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [itemOrderList, setItemOrderList] = useState(null);
  const [orderIngedientList, setOrderIngredientList] = useState(null);
  const [ingredientList, setIngredientList] = useState([]);
  const [loading, setLoading] = useState(false)
  const [noRecordsFound, setNoRecordsFound] = useState(false);
  
  useEffect(() => {
    getIngredientReceiptList();
  }, [fromDate, toDate, ingredient, receiptStatus])

  useEffect(()=>{
    console.log(ingredientReceiptList)
    getIngredientList()
  },[ingredientReceiptList])

  const handelFilterChange = async (from_date, to_date, session, item, requirement_status, order_status, order_id, purchase_status, receipt_status, issue_status, ingredient) => {
    setFromDate(from_date);
    setToDate(to_date);
    // setIngredient(ingredient); 
    // setReceiptStatus(receipt_status);
    setIngredient(Array.isArray(ingredient) ? ingredient : ingredient ? [ingredient] : []);
    setReceiptStatus(Array.isArray(receipt_status) ? receipt_status : receipt_status ? [receipt_status] : []);
  };

  const getIngredientList = async () => {
    const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
    const existingIngredientIds = ingredientReceiptList.map(item => item.ingredient_id);
    const list = response.data.data.filter((item) => item.status == 1 && item?.store?.id == 3 && !existingIngredientIds.includes(item.id));
    setIngredientList(list);
  };

  const getIngredientReceiptList = async() => {
    setLoading(true)
    setNoRecordsFound(false)
    const ingredientArr = Array.isArray(ingredient) ? ingredient : ingredient ? [ingredient] : [];
    const receiptStatusArr = Array.isArray(receiptStatus) ? receiptStatus : receiptStatus ? [receiptStatus] : [];
    const ingredientIds = ingredientArr.map(i => i.value).join(',');
    const receiptStatusValues = receiptStatusArr.map(s => s.value).join(',');
    console.log("receipt value:", receiptStatus.value)
    const response = await axios.post(`${baseUrl}/receipt/list`,
      { from_date : fromDate,
        to_date :toDate,
        ingredient : ingredientIds,
        receipt_status : receiptStatusValues
      
    });
    const updatedArray = response?.data?.data.map(item => ({
      ...item,         // Spread existing properties
      purchase_qty: item.purchase_qty ?? "", 
      pur_pack_nos: item?.pur_pack_nos ?? 0,         // Add new key-value pair
      received_qty: item.received_qty ?? "",
      rec_pack_nos: item?.rec_pack_nos ?? 0,
      diff_qty : item.received_qty - item.purchase_qty ?? 0,
      diff_pack : item.rec_pack_nos - item.pur_pack_nos ?? 0,
      add_received:false,
      add_pack_nos: false
  }));
    setIngredientReceiptList(updatedArray);
    setNoRecordsFound(updatedArray.length === 0);
    setLoading(false)
  }

  const handleToggleSelect = (index) => {
    const updatedSelectedRows = selectedRows.includes(ingredientReceiptList[index])
        ? selectedRows.filter(item => item !== ingredientReceiptList[index]) // Deselect
        : [...selectedRows, ingredientReceiptList[index]]; // Select

   setSelectedRows(updatedSelectedRows);
  };

  const handleSwitchSelectAll = () => {
    if (selectAll) {
        setSelectedRows([]);
    } else {
        setSelectedRows(ingredientReceiptList.filter((item) => item.receipt_status == 1)); // Select all rows
    }
    setSelectAll(!selectAll);
  };

  const displayIngredientDetail = async(e, item) => {
    e.preventDefault();
    setLoading(true)
    const condition = `ingredient_id = '${item.ingredient_id}' AND order_status = 3 AND purchase_status = 3`;
    const response = await axios.get(
        `${baseUrl}/comman/list?table=item_requirement_summary&condition=${condition}`
    );
    const orderList = response.data.data;
    setItemOrderList(orderList);
    setLoading(false)
    setShowModal(true);
  }

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    
    setIngredientReceiptList((prevFormData) => {
      if(name === 'rec_pack_nos' || name === 'add_pack_nos_qty'){
        const updatedFormData = [...prevFormData];
        const pur_pack_nos = updatedFormData[index].pur_pack_nos;
        const diff_pack = (value - pur_pack_nos).toFixed(2);
        updatedFormData[index] = { ...updatedFormData[index], [name]: value, diff_pack : diff_pack };
        return updatedFormData;
      }else{
        const updatedFormData = [...prevFormData];
        const purchase_qty = updatedFormData[index].purchase_qty;
        const diff_qty = (value - purchase_qty).toFixed(2);
        updatedFormData[index] = { ...updatedFormData[index], [name]: value, diff_qty : diff_qty };
        return updatedFormData;
      }
    });
  };

  const handleAddButtonClick = (index, type) => {
    setIngredientReceiptList((prevFormData) => {
      const updatedFormData = [...prevFormData]
      const updatedItem = { ...updatedFormData[index] };

      if (type == 1) {
        updatedItem.add_received = true;
      }
      else if (type == 2) {
        updatedItem.add_pack_nos = true;
      }
      updatedFormData[index] = updatedItem;
      console.log(updatedFormData[index])
      return updatedFormData

    });

  }

  const clearItem = () => {
    setSelectedRows([]);
    setItemOrderList(null);
    setOrderIngredientList(null);
    getIngredientReceiptList();
  };

  const handleSubmit = async() => {
    if(selectedRows.length == 0){
      alert("Please select at least one row");
      setSelectedRows([]);
      return;
    }
    console.log(selectedRows);
    if(selectedRows.some(item => item.received_qty === "")){
      alert("One or more items have an empty recieved qty value.");
      setSelectedRows([]);
      return;
    }
    if(selectedRows.some(item => item.add_received_qty === "")){
      alert("One or more items have an empty additional recieved qty value.");
      setSelectedRows([]);
      return;
    }
    if(selectedRows.some(item => item.ingredient_id === null)){
      alert("One or more items have an empty ingredient value.");
      setSelectedRows([])
      return
    }
    if(selectedRows.length > 0){
      setLoading(true);
        try{
            const response = await axios.post(`${baseUrl}/receipt/ingredient_purchase`,
              { ingredientsList : selectedRows
                });
                const msg = response.data.msg;
                await getIngredientReceiptList();
                toast.success(msg);
                //await getIngredientReceiptList();
          }catch (error) {
            toast.error("Failed to add item. Please try again.");
          }finally {
      setLoading(false); // always stop loading
      setSelectedRows([]); // clear selection here for consistency
    }
    }
    // setSelectedRows([])
  };

  const handleSave = async() => {
    const list = ingredientReceiptList.filter((item) => item.ingredient_id !== null);
    if(ingredientReceiptList.some(item => item.ingredient_id === null)){
      alert("One or more items have an empty ingredient value.");
      setSelectedRows([])
      return
    }
    setLoading(true);
    if(list.length > 0){
      try{
        
        const response = await axios.post(`${baseUrl}/receipt/ingredient_save`,
          { 
            ingredientsList : list
          });
          toast.success("Data save sucessfully.");
          await getIngredientReceiptList();
      }catch (error) {
        toast.error("Failed to add item. Please try again.");
      } finally {
        setLoading(false)
        setSelectedRows([])
      }
    }
    
  }

  const handleAddNewIngredientRow = () => {
    setIngredientReceiptList([...ingredientReceiptList, {
      ingredient: '',
      ingredient_obj:{},
      ingredient_id: null,
      total_order: 0,
      purchase_qty: 0,
      pur_pack_nos: 0,
      received_qty: '',
      rec_pack_nos: '',
      diff_qty: 0,
      purchase_status: 3,
      receipt_status:1,
      isNew: true
    }]);
  };

  const handleNewIngredientChange = (selectedOptions,index) => {
    // setNewIngredient((prev)=>({...prev,ingredient:ingredient}))
    console.log(selectedOptions)
    const updatedList =   [...ingredientReceiptList]
    updatedList[index].ingredient_obj = selectedOptions
    updatedList[index].ingredient = selectedOptions.ingredient
    updatedList[index].ingredient_id = selectedOptions.value
    setIngredientReceiptList(updatedList)
  }

  return (
    <div className="p-2 sm:p-4">
      {loading && <Loader />}
      <div className="flex justify-between items-center py-2 sm:py-4 px-2 sm:px-6">
        <h1 className="text-lg sm:text-xl font-bold">
          Veg Receipt (Gross)
        </h1>

        <Toaster position="top-center" reverseOrder={false} />
      </div>

      <div className="relative shadow-md sm:rounded-lg">
        <VegRequirementFilter handleFilterChange={handelFilterChange} page="receipt" />
      </div>

      {noRecordsFound && <NoRecordsFound />}

      {ingredientReceiptList.length > 0 && (
        <div className="w-full">
          {/* Desktop Table View */}
          <div className="hidden lg:block overflow-x-auto">
            <div className="max-w-full overflow-visible pb-2">
              <table className="w-full mt-4 text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 table-auto min-w-full">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0">
                  <tr>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">
                      <input
                        type="checkbox"
                        className="newrow checkboxAll"
                        onChange={handleSwitchSelectAll}
                        checked={selectAll}
                      />
                    </th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">શાકભાજીનું નામ</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap" colSpan='2'>મળેલ</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap" colSpan='2'>ખરીદેલ</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap" colSpan='2'>તફાવત</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">સ્ટેટસ</th>
                  </tr>
                  <tr>
                    <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                    <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">વજન</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">દાગીના</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">વજન</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">દાગીના</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">વજન</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center whitespace-nowrap">દાગીના</th>
                    <th scope="col" className="px-2 py-1 border border-black text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {ingredientReceiptList.map((item, index) => (
                    <tr key={index} className="border border-black-b hover:bg-gray-50">
                      {(item.receipt_status !== 3) || ((item.receipt_status == 3) && ((item.add_pack_nos) || (item.add_received))) ? (
                        <td className="px-2 py-1 border border-black text-center">
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(item)}
                            onChange={() => handleToggleSelect(index)}
                          />
                        </td>
                      ) : (
                        <td className="px-2 py-1 border border-black text-center"></td>
                      )}
                      <td className="px-2 py-1 border border-black text-center relative">
                        {item.isNew ? (
                          <Select
                            classNamePrefix="select"
                            className='basic-multi-select w-40 sm:w-auto'
                            value={item.ingredient_obj}
                            name="ingredient"
                            onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                            options={ingredientList.map((item) => ({
                              value: item.id,
                              label: `${item.ingredient} (${item.eng_name})`,
                              unit: item.unit?.id,
                              ingredient: `${item.ingredient}`,
                              eng_name: item.eng_name,
                            }))}
                            placeholder="Ingredient List"
                            filterOption={(option, inputValue) => {
                              return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                            }}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999
                              })
                            }}
                          />
                        ) : (item.ingredient)}
                      </td>
                      <td className="px-0 py-1 border border-black text-center">
                        <div className="flex flex-col sm:flex-row items-center justify-center space-y-1 sm:space-y-0 sm:space-x-1">
                          <input
                            type="number"
                            id="received_qty"
                            name="received_qty"
                            disabled={item.receipt_status == 3}
                            value={item?.received_qty ?? ''}
                            onWheel={(e) => e.target.blur()}
                            onChange={handleInputChange(index)}
                            onKeyDown={(e) => {
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                          />
                          {(item.receipt_status === 3 || item.receipt_status === 1 || item.receipt_status === 0 || item.receipt_status === 2 || item.receipt_status === 4) && (
                            <>
                              <button
                                onClick={() => { handleAddButtonClick(index, 1) }}
                                className='px-1 rounded border mx-2 scale-150 hover:bg-gray-300'
                              >
                                &#x2b;
                              </button>
                              {item.add_received && (
                                <input
                                  type="number"
                                  id="add_received_qty"
                                  name="add_received_qty"
                                  value={item?.add_received_qty ?? ''}
                                  onWheel={(e) => e.target.blur()}
                                  onChange={handleInputChange(index)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                      e.preventDefault();
                                    }
                                  }}
                                  className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                                />
                              )}
                            </>
                          )}
                        </div>
                      </td>
                      <td className="px-2 py-1 border border-black text-center">
                        <div className="flex flex-col sm:flex-row items-center justify-center space-y-1 sm:space-y-0 sm:space-x-1">
                          <input
                            type="number"
                            id="rec_pack_nos"
                            name="rec_pack_nos"
                            disabled={item.receipt_status == 3}
                            value={item?.rec_pack_nos ?? 0}
                            onWheel={(e) => e.target.blur()}
                            onChange={handleInputChange(index)}
                            onKeyDown={(e) => {
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                          />
                          {(item.receipt_status === 3 || item.receipt_status === 1 || item.receipt_status === 0 || item.receipt_status === 2 || item.receipt_status === 4) && (
                            <>
                              <button
                                onClick={() => { handleAddButtonClick(index, 2) }}
                                className='px-1 rounded border mx-2 scale-150 hover:bg-gray-300'
                              >
                                &#x2b;
                              </button>
                              {item.add_pack_nos && (
                                <input
                                  type="number"
                                  id="add_pack_nos_qty"
                                  name="add_pack_nos_qty"
                                  value={item?.add_pack_nos_qty ?? ''}
                                  onWheel={(e) => e.target.blur()}
                                  onChange={handleInputChange(index)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                      e.preventDefault();
                                    }
                                  }}
                                  className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                                />
                              )}
                            </>
                          )}
                        </div>
                      </td>
                      <td className="px-2 py-1 border border-black text-center">
                        <a
                          href="#"
                          className="underline text-blue-500"
                          onClick={(e) => displayIngredientDetail(e, item)}
                        >
                          {item.purchase_qty}
                        </a>
                      </td>
                      <td className="px-2 py-1 border border-black text-center">{item.pur_pack_nos}</td>
                      <td className={`px-2 py-1 border border-black text-center ${item.diff_qty < 0 ? 'bg-red-500 text-black' : item.diff_qty > 0 ? 'bg-yellow-300 text-black' : ''}`}>
                        {parseInt(item.diff_qty).toFixed(2)}
                      </td>
                      <td className={`px-2 py-1 border border-black text-center ${item.diff_pack < 0 ? 'bg-red-500 text-black' : item.diff_pack > 0 ? 'bg-yellow-300 text-black' : ''}`}>
                        {item.diff_pack}
                      </td>
                      <td className="px-2 py-1 border border-black text-center whitespace-nowrap">
                        {item.receipt_status == 1 ? "Pending Receipt" : (item.receipt_status == 2 ? "Partly Received" : (item.receipt_status == 3 ? "Received" : "Excess Received"))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile Card View */}
        <div className="lg:hidden mt-4">
          {/* Mobile Select All Section */}
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 mb-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  className="newrow checkboxAll rounded"
                  onChange={handleSwitchSelectAll}
                  checked={selectAll}
                />
                <label className="text-sm font-medium text-gray-700">Select All</label>
              </div>
              <div className="text-sm text-gray-600">
                {selectedRows.length} of {ingredientReceiptList.length} selected
              </div>
            </div>
          </div>

          {/* Mobile Cards */}
          <div className="space-y-4">
            {ingredientReceiptList.map((item, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-lg shadow-sm p-4">
                {/* Header with checkbox and ingredient name */}
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center space-x-3">
                    {(item.receipt_status !== 3) || ((item.receipt_status == 3) && ((item.add_pack_nos) || (item.add_received))) ? (
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(item)}
                        onChange={() => handleToggleSelect(index)}
                        className="rounded"
                      />
                    ) : (
                      <div className="w-4 h-4"></div>
                    )}
                    <div className="flex-1">
                      {item.isNew ? (
                        <Select
                          classNamePrefix="select"
                          className='basic-multi-select w-full'
                          value={item.ingredient_obj}
                          name="ingredient"
                          onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                          options={ingredientList.map((item) => ({
                            value: item.id,
                            label: `${item.ingredient} (${item.eng_name})`,
                            unit: item.unit?.id,
                            ingredient: `${item.ingredient}`,
                            eng_name: item.eng_name,
                          }))}
                          placeholder="Ingredient List"
                          filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                          }}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={{
                            menuPortal: (base) => ({ 
                              ...base, 
                              zIndex: 9999 
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 9999
                            })
                          }}
                        />
                      ) : (
                        <h3 className="font-semibold text-gray-900">{item.ingredient}</h3>
                      )}
                    </div>
                  </div>
                  <div className="text-sm px-2 py-1 rounded-full bg-gray-100">
                    {item.receipt_status == 1 ? "Pending" : (item.receipt_status == 2 ? "Partly Received" : (item.receipt_status == 3 ? "Received" : "Excess"))}
                  </div>
                </div>

                {/* Quantities Grid */}
                <div className="grid grid-cols-2 gap-4 mb-3">
                  {/* Received Section */}
                  <div className="bg-orange-50 p-3 rounded-lg">
                    <h4 className="text-sm font-semibold text-gray-700 mb-2">મળેલ</h4>
                    <div className="space-y-2">
                      <div>
                        <label className="text-xs text-gray-600">વજન</label>
                        <div className="flex items-center space-x-1">
                          <input
                            type="number"
                            id="received_qty"
                            name="received_qty"
                            disabled={item.receipt_status == 3}
                            value={item?.received_qty ?? ''}
                            onWheel={(e) => e.target.blur()}
                            onChange={handleInputChange(index)}
                            onKeyDown={(e) => {
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className="px-2 py-1 border rounded-md w-16 bg-white text-sm"
                          />
                          {(item.receipt_status === 3 || item.receipt_status === 1 || item.receipt_status === 0 || item.receipt_status === 2 || item.receipt_status === 4) && (
                            <button
                              onClick={() => { handleAddButtonClick(index, 1) }}
                              className='px-1 rounded border hover:bg-gray-300 text-sm'
                            >
                              &#x2b;
                            </button>
                          )}
                        </div>
                        {item.add_received && (
                          <input
                            type="number"
                            id="add_received_qty"
                            name="add_received_qty"
                            value={item?.add_received_qty ?? ''}
                            onWheel={(e) => e.target.blur()}
                            onChange={handleInputChange(index)}
                            onKeyDown={(e) => {
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className="px-2 py-1 border rounded-md w-16 bg-white text-sm mt-1"
                          />
                        )}
                      </div>
                      <div>
                        <label className="text-xs text-gray-600">દાગીના</label>
                        <div className="flex items-center space-x-1">
                          <input
                            type="number"
                            id="rec_pack_nos"
                            name="rec_pack_nos"
                            disabled={item.receipt_status == 3}
                            value={item?.rec_pack_nos ?? 0}
                            onWheel={(e) => e.target.blur()}
                            onChange={handleInputChange(index)}
                            onKeyDown={(e) => {
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className="px-2 py-1 border rounded-md w-16 bg-white text-sm"
                          />
                          {(item.receipt_status === 3 || item.receipt_status === 1 || item.receipt_status === 0 || item.receipt_status === 2 || item.receipt_status === 4) && (
                            <button
                              onClick={() => { handleAddButtonClick(index, 2) }}
                              className='px-1 rounded border hover:bg-gray-300 text-sm'
                            >
                              &#x2b;
                            </button>
                          )}
                        </div>
                        {item.add_pack_nos && (
                          <input
                            type="number"
                            id="add_pack_nos_qty"
                            name="add_pack_nos_qty"
                            value={item?.add_pack_nos_qty ?? ''}
                            onWheel={(e) => e.target.blur()}
                            onChange={handleInputChange(index)}
                            onKeyDown={(e) => {
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className="px-2 py-1 border rounded-md w-16 bg-white text-sm mt-1"
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Purchased Section */}
                  <div className="bg-blue-50 p-3 rounded-lg">
                    <h4 className="text-sm font-semibold text-gray-700 mb-2">ખરીદેલ</h4>
                    <div className="space-y-2">
                      <div>
                        <label className="text-xs text-gray-600">વજન</label>
                        <div>
                          <a
                            href="#"
                            className="underline text-blue-500 text-sm font-medium"
                            onClick={(e) => displayIngredientDetail(e, item)}
                          >
                            {item.purchase_qty}
                          </a>
                        </div>
                      </div>
                      <div>
                        <label className="text-xs text-gray-600">દાગીના</label>
                        <div className="text-sm font-medium">{item.pur_pack_nos}</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Difference Section */}
                <div className="bg-gray-50 p-3 rounded-lg">
                  <h4 className="text-sm font-semibold text-gray-700 mb-2">તફાવત</h4>
                  <div className="flex justify-between">
                    <div>
                      <label className="text-xs text-gray-600">વજન</label>
                      <div className={`text-sm font-medium px-2 py-1 rounded ${item.diff_qty < 0 ? 'bg-red-500 text-white' : item.diff_qty > 0 ? 'bg-yellow-300 text-black' : ''}`}>
                        {parseInt(item.diff_qty).toFixed(2)}
                      </div>
                    </div>
                    <div>
                      <label className="text-xs text-gray-600">દાગીના</label>
                      <div className={`text-sm font-medium px-2 py-1 rounded ${item.diff_pack < 0 ? 'bg-red-500 text-white' : item.diff_pack > 0 ? 'bg-yellow-300 text-black' : ''}`}>
                        {item.diff_pack}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

          <IngredientBatchModel
            showModal={showModal}
            setShowModal={setShowModal}
            detailList={itemOrderList}
            clearItem={clearItem}
            type={3}
          />

          <div className='m-2 sm:m-5 flex flex-wrap gap-2'>
            {ingredientReceiptList.every(item => item.receipt_status === 1) && (
              <button
                onClick={handleSave}
                className="px-3 py-2 sm:px-4 sm:py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
              >
                Save
              </button>
            )}
            <button
              onClick={handleAddNewIngredientRow}
              className="px-3 py-2 sm:px-4 sm:py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
            >
              શાકભાજી ઉમેરો
            </button>
            <button
              onClick={handleSubmit}
              className="px-3 py-2 sm:px-4 sm:py-2 bg-rose-500 text-white rounded-md hover:bg-rose-600 focus:outline-none focus:ring focus:ring-rose-200"
            >
              મળેલ
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default ReceiptList;